export default __webpack_public_path__ + "static/media/emptyClientList.fbaa8cac.svg";